import { toUserMessage, UserFacingError } from '../errors.js';

/** Keep native errors useful after JSON persistence, without logging job data. */
export function serializePrintError(error: unknown, seen = new Set<unknown>()): Record<string, unknown> {
  if (seen.has(error)) return { message: '[circular cause]' };
  if (seen.size >= 5) return { message: '[cause depth limit]' };
  seen.add(error);
  const clean = (value: string, limit: number): string => value
    .replace(/Bearer\s+\S+/gi, 'Bearer [redacted]')
    .replace(/\beyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\b/g, '[redacted JWT]')
    .replace(/([?&](?:[^=\s]+)=)[^&\s]+/g, '$1[redacted]')
    .replace(/((?:password|token|secret|api[_-]?key|pin)\s*[:=]\s*)[^\s,;]+/gi, '$1[redacted]')
    .slice(0, limit);
  if (!error || typeof error !== 'object') return { message: clean(String(error), 1500) };
  const source = error as Record<string, unknown>;
  const result: Record<string, unknown> = {};
  for (const key of ['name', 'message', 'code', 'errorMessage', 'stack', 'stage', 'finalChunk']) {
    const value = source[key];
    if (typeof value === 'string') result[key] = clean(value, key === 'stack' ? 3000 : 1500);
    else if (typeof value === 'number' || typeof value === 'boolean') result[key] = value;
  }
  if (source.cause !== undefined) result.cause = serializePrintError(source.cause, seen);
  return result;
}

export class LabelPrintStageError extends UserFacingError {
  constructor(readonly stage: 'render' | 'write', readonly cause: unknown) {
    super(toUserMessage(cause, 'Stampa non riuscita. Controlla la stampante e riprova.'));
    this.name = 'LabelPrintStageError';
  }
}
